import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Mail, Shield, TrendingUp } from 'lucide-react';
import { useI18n } from '../../i18n/useI18n';

const Footer: React.FC = () => {
  const { t } = useI18n();

  return (
    <footer className="bg-primary-900 text-white">
      <div className="container-news py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="font-playfair text-2xl font-bold mb-4">
              {t('site.name')}
            </h3>
            <p className="text-primary-300 mb-4 leading-relaxed">
              {t('footer.desc')}
            </p>
            <div className="flex items-center space-x-4 text-sm">
              <span className="flex items-center">
                <Globe className="h-4 w-4 mr-1" />
                {t('footer.globalCoverage')}
              </span>
              <span className="flex items-center">
                <Shield className="h-4 w-4 mr-1" />
                {t('footer.biasAnalyzed')}
              </span>
              <span className="flex items-center">
                <TrendingUp className="h-4 w-4 mr-1" />
                {t('footer.impactScored')}
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-4">{t('footer.navigate')}</h4>
            <ul className="space-y-2 text-primary-300">
              <li><Link to="/" className="hover:text-white transition-colors">{t('footer.latestNews')}</Link></li>
              <li><Link to="/category/Geopolitics" className="hover:text-white transition-colors">{t('footer.geopolitics')}</Link></li>
              <li><Link to="/category/Economy" className="hover:text-white transition-colors">{t('footer.economy')}</Link></li>
              <li><Link to="/category/Climate" className="hover:text-white transition-colors">{t('footer.environment')}</Link></li>
              <li><Link to="/category/Technology" className="hover:text-white transition-colors">{t('footer.technology')}</Link></li>
            </ul>
          </div>

          {/* Impact */}
          <div>
            <h4 className="font-playfair text-lg font-semibold mb-4">{t('footer.impact')}</h4>
            <ul className="space-y-2 text-primary-300">
              <li><span className="hover:text-white transition-colors cursor-pointer">{t('footer.howWeScore')}</span></li>
              <li><span className="hover:text-white transition-colors cursor-pointer">{t('footer.biasMethod')}</span></li>
              <li><span className="hover:text-white transition-colors cursor-pointer">{t('footer.ethixStaking')}</span></li>
              <li><span className="hover:text-white transition-colors cursor-pointer">{t('footer.sustainableImpact')}</span></li>
            </ul>
            <div className="mt-6">
              <a href="mailto:news@unbiasednews.xyz" className="flex items-center text-accent-400 hover:text-accent-300 transition-colors">
                <Mail className="h-4 w-4 mr-2" />
                news@unbiasednews.xyz
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-primary-400">
            <div className="mb-4 md:mb-0">{t('footer.copyright')}</div>
            <div className="flex items-center space-x-6">
              <span>{t('footer.privacy')}</span>
              <span>{t('footer.terms')}</span>
              <span>{t('footer.editorial')}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Impact Stats Bar */}
      <div className="bg-primary-950 border-t border-primary-800">
        <div className="container-news py-4">
          <div className="flex items-center justify-center space-x-8 text-sm text-primary-400">
            <div className="text-center">
              <div className="text-white font-bold text-lg">2,847</div>
              <div>{t('footer.analyzed')}</div>
            </div>
            <div className="text-center">
              <div className="text-white font-bold text-lg">15.2K</div>
              <div>{t('footer.ethixStaked')}</div>
            </div>
            <div className="text-center">
              <div className="text-white font-bold text-lg">97%</div>
              <div>{t('footer.biasRate')}</div>
            </div>
            <div className="text-center">
              <div className="text-white font-bold text-lg">Global</div>
              <div>{t('footer.reach')}</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;